import { render, staticRenderFns } from "./ContributionRangeSetting.vue?vue&type=template&id=02a22200"
import script from "./ContributionRangeSetting.vue?vue&type=script&lang=js"
export * from "./ContributionRangeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports